// @flow
import React from "react";
import PageContainer from "../containers/PageContainer";
import MyProfile from "../containers/MyProfile";
import { useTranslation } from 'react-i18next';


export default function AccountView(props) {
    const { t } = useTranslation();
    return (
        <PageContainer title={t("My Profile")} showShopToolbar={false}>
            <MyProfile navSection={props.match.params.navSection} />
        </PageContainer>

    );
}
